var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 297.001 297.001",
    style: {
      enableBackground: "new 0 0 297.001 297.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#edfcf2",
    d: "M227.289,106.022c-2.303,0-4.62,0.117-6.931,0.349c-8.746-32.121-38.001-54.816-71.858-54.816 S85.388,74.25,76.642,106.371c-2.311-0.232-4.628-0.349-6.931-0.349C31.272,106.022,0,137.294,0,175.733 c0,38.439,31.272,69.712,69.711,69.712H227.29c38.439,0,69.711-31.273,69.711-69.712 C297.001,137.294,265.728,106.022,227.289,106.022z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.e906abd806ae19a6f8bb52e6e5c1b4c2.svg";
export { ForwardRef as ReactComponent };